var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluentMdl2DocumentApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 68,
    viewBox: "0 0 74 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 52,
    rx: 34.5,
    ry: 11.5,
    fill: "#D5EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_535)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 40.5,
    width: 37,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2612 53.3306L48.4378 53.5062L48.6141 53.3303L59.8387 42.1297L61.6827 43.9738L48.4377 57.2426L42.2233 51.0052L44.0679 49.1607L48.2612 53.3306ZM56 39.6464L53.375 42.2714V24.125V23.875H53.125H40.875V11.625V11.375H40.625H18.75H18.5V11.625V55.375V55.625H18.75H40.375V58.25H15.875V8.75H42.7431L56 22.0069V39.6464ZM43.5 21V21.25H43.75H50.9033H51.5069L51.0801 20.8232L43.9268 13.6699L43.5 13.2431V13.8467V21Z",
    fill: "#0593F5",
    stroke: "#D5EEFF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(12.5 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMdl2DocumentApproval);
export default __webpack_public_path__ + "static/media/fluent-mdl2_document-approval.e810dbea1c457a693227771dd8162379.svg";
export { ForwardRef as ReactComponent };